import { createContext } from 'react';
import { IChartContext } from './chart.interface';

export const ChartContext = createContext<IChartContext>({
  width: 0,
  height: 0,
});
